'use strict';

angular.module('theme').directive('zipcodeCheck', function (ZipCodeService) {
	return {
		restrict: 'E',
		templateUrl: 'component/zipcode-check.html',
		scope: true,
		controller: function ($scope) {

			$scope.status = -1;

			$scope.check = function (zipcode) {
				$scope.status = -2; // Loading
				ZipCodeService.check(zipcode).then(function (response) {
					$scope.status = response.zipcodeStatus;
				});
			};
		}
	};
});
